import React from 'react'
import getTemplateVariables from './helpers/getTemplateVariables'
import styled from '@emotion/styled'

type Props = {
  email: {
    to?: string
    bcc?: string
    subject: string
    body: string
  }
  invoice: any
  invoiceSettings: any
}

const EmailWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #fafbfc;
`

const Email = styled.div`
  width: 100%;
  padding: 50px;
  position: relative;
  overflow: hidden;
  width: 600px;
  background: white;
  //min-height: 300px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`

const EmailSubject = styled.h3`
  margin-bottom: 1.5rem;
`
const EmailBody = styled.div`
  white-space: pre-wrap;
`

const EmailRender: React.FC<Props> = (props) => {
  const variables = getTemplateVariables(props.invoice, props.invoiceSettings)
  const { replaceVariables } = variables
  const {
    email: { subject, body }
  } = props
  return (
    <EmailWrapper>
      <Email>
        <EmailSubject>{replaceVariables(subject, variables)}</EmailSubject>
        <EmailBody>{replaceVariables(body, variables)}</EmailBody>
      </Email>
    </EmailWrapper>
  )
}

export default EmailRender
